var _window$dataLayer;
import { jsx as m, Fragment as Z, jsxs as N } from "react/jsx-runtime";
import v, { useState as I, useCallback as S, useRef as q, useLayoutEffect as G, useEffect as j } from "react";
var H = function () {},
  K = typeof window < "u";
function Q(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var J = {
  exports: {}
};
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function (e, o) {
  (function (a) {
    var n;
    if (e.exports = a(), n = !0, !n) {
      var d = window.Cookies,
        r = window.Cookies = a();
      r.noConflict = function () {
        return window.Cookies = d, r;
      };
    }
  })(function () {
    function a() {
      for (var r = 0, c = {}; r < arguments.length; r++) {
        var f = arguments[r];
        for (var _ in f) c[_] = f[_];
      }
      return c;
    }
    function n(r) {
      return r.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function d(r) {
      function c() {}
      function f(l, i, s) {
        if (!(typeof document > "u")) {
          s = a({
            path: "/"
          }, c.defaults, s), typeof s.expires == "number" && (s.expires = new Date( /* @__PURE__ */new Date() * 1 + s.expires * 864e5)), s.expires = s.expires ? s.expires.toUTCString() : "";
          try {
            var u = JSON.stringify(i);
            /^[\{\[]/.test(u) && (i = u);
          } catch {}
          i = r.write ? r.write(i, l) : encodeURIComponent(String(i)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), l = encodeURIComponent(String(l)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var h = "";
          for (var t in s) s[t] && (h += "; " + t, s[t] !== !0 && (h += "=" + s[t].split(";")[0]));
          return document.cookie = l + "=" + i + h;
        }
      }
      function _(l, i) {
        if (!(typeof document > "u")) {
          for (var s = {}, u = document.cookie ? document.cookie.split("; ") : [], h = 0; h < u.length; h++) {
            var t = u[h].split("="),
              p = t.slice(1).join("=");
            !i && p.charAt(0) === '"' && (p = p.slice(1, -1));
            try {
              var C = n(t[0]);
              if (p = (r.read || r)(p, C) || n(p), i) try {
                p = JSON.parse(p);
              } catch {}
              if (s[C] = p, l === C) break;
            } catch {}
          }
          return l ? s[l] : s;
        }
      }
      return c.set = f, c.get = function (l) {
        return _(l, !1
        /* read as raw */);
      }, c.getJSON = function (l) {
        return _(l, !0
        /* read as json */);
      }, c.remove = function (l, i) {
        f(l, "", a(i, {
          expires: -1
        }));
      }, c.defaults = {}, c.withConverter = d, c;
    }
    return d(function () {});
  });
})(J);
var X = J.exports;
const B = /* @__PURE__ */Q(X);
var V = function (e) {
  var o = I(function () {
      return B.get(e) || null;
    }),
    a = o[0],
    n = o[1],
    d = S(function (c, f) {
      B.set(e, c, f), n(c);
    }, [e]),
    r = S(function () {
      B.remove(e), n(null);
    }, [e]);
  return [a, d, r];
};
const M = V;
var ee = function (e, o, a) {
  if (!K) return [o, H, H];
  if (!e) throw new Error("useLocalStorage key may not be falsy");
  var n = a ? a.raw ? function (i) {
      return i;
    } : a.deserializer : JSON.parse,
    d = q(function (i) {
      try {
        var s = a ? a.raw ? String : a.serializer : JSON.stringify,
          u = localStorage.getItem(i);
        return u !== null ? n(u) : (o && localStorage.setItem(i, s(o)), o);
      } catch {
        return o;
      }
    }),
    r = I(function () {
      return d.current(e);
    }),
    c = r[0],
    f = r[1];
  G(function () {
    return f(d.current(e));
  }, [e]);
  var _ = S(function (i) {
      try {
        var s = typeof i == "function" ? i(c) : i;
        if (typeof s > "u") return;
        var u = void 0;
        a ? a.raw ? typeof s == "string" ? u = s : u = JSON.stringify(s) : a.serializer ? u = a.serializer(s) : u = JSON.stringify(s) : u = JSON.stringify(s), localStorage.setItem(e, u), f(n(u));
      } catch {}
    }, [e, f]),
    l = S(function () {
      try {
        localStorage.removeItem(e), f(void 0);
      } catch {}
    }, [e, f]);
  return [c, _, l];
};
const ne = ee;
function R(e) {
  var o,
    a,
    n = "";
  if (typeof e == "string" || typeof e == "number") n += e;else if (typeof e == "object") if (Array.isArray(e)) for (o = 0; o < e.length; o++) e[o] && (a = R(e[o])) && (n && (n += " "), n += a);else for (o in e) e[o] && (n && (n += " "), n += o);
  return n;
}
function A() {
  for (var e, o, a = 0, n = ""; a < arguments.length;) (e = arguments[a++]) && (o = R(e)) && (n && (n += " "), n += o);
  return n;
}
const ae = _ref => {
    let {
      buttonText: e = "Accept",
      text: o = "This website uses cookies to improve and facilitate access to the website and to keep statistical data. Your continued use of using this site constitutes acceptance of this.",
      links: a = [{
        name: "Privacy policy",
        link: "#"
      }, {
        name: "How to disable cookie?",
        link: "#"
      }, {
        name: "Cybersecurity",
        link: "#"
      }],
      expires: n = /* @__PURE__ */new Date().getDate() + 7,
      setCookie: d = !0,
      ...r
    } = _ref;
    const [c, f] = M("cookie-information"),
      [_, l] = I(!1),
      [i, s] = I(!1),
      u = () => {
        var t, p;
        d ? (f("cookie-information", {
          expires: n
        }), (t = r.onCookieSet) == null || t.call(r)) : (s(!0), (p = r.onHide) == null || p.call(r));
      };
    j(() => {
      setTimeout(() => l(!0), 1e3);
    }, [l]), j(() => {
      var t;
      c && ((t = r.onHide) == null || t.call(r));
    }, [c, r.onHide]);
    const h = d ? !c && _ : !i;
    return /* @__PURE__ */m(Z, {
      children: /* @__PURE__ */N("div", {
        className: A("rendpro-cookie-notice", r.className, h && "is-active"),
        style: {
          "--rendpro-cookie-notice-background-color": r.backgroundColor,
          "--rendpro-cookie-notice-foreground-color": r.foregroundColor,
          "--rendpro-cookie-notice-button-background-color": r.buttonBackgroundColor,
          "--rendpro-cookie-notice-button-color": r.buttonColor,
          "--rendpro-cookie-notice-links-color": r.linksColor
        },
        children: [/* @__PURE__ */m("div", {
          className: "rendpro-cookie-notice__cookie-info",
          children: o
        }), /* @__PURE__ */m("div", {
          className: "rendpro-cookie-notice__links-wrapper",
          children: a.map(_ref2 => {
            let {
              name: t,
              link: p,
              render: C
            } = _ref2;
            return C ? /* @__PURE__ */m(C, {
              name: t,
              link: p,
              className: "rendpro-cookie-notice__link"
            }, t) : /* @__PURE__ */m("a", {
              href: p,
              target: "_blank",
              rel: "noopener",
              className: "rendpro-cookie-notice__link",
              children: t
            }, t);
          })
        }), /* @__PURE__ */m("button", {
          onClick: u,
          className: "rendpro-cookie-notice__button",
          children: e
        })]
      })
    });
  },
  re = e => {
    const o = {
      wrapper: "rendpro-consentmode-banner__wrapper",
      innerWrapper: "rendpro-consentmode-banner__innerWrapper",
      wrapperOpened: "rendpro-consentmode-banner__wrapper--opened",
      frame: "rendpro-consentmode-banner__frame",
      frameOpened: "rendpro-consentmode-banner__frame--opened",
      contentWrapper: "rendpro-consentmode-banner__contentWrapper",
      title: "rendpro-consentmode-banner__title",
      subtitle: "rendpro-consentmode-banner__subtitle",
      description: "rendpro-consentmode-banner__description",
      consentsWrapper: "rendpro-consentmode-banner__consentsWrapper",
      consent: "rendpro-consentmode-banner__consent",
      consentLabel: "rendpro-consentmode-banner__consentLabel",
      consentDisabled: "rendpro-consentmode-banner__consent--disabled",
      consentCheckbox: "rendpro-consentmode-banner__consentCheckbox",
      buttonsWrapper: "rendpro-consentmode-banner__buttonsWrapper",
      denyAll: "rendpro-consentmode-banner__denyAll",
      save: "rendpro-consentmode-banner__save",
      grantAll: "rendpro-consentmode-banner__grantAll"
    };
    return e ? {
      ...o,
      ...e
    } : o;
  },
  ie = _ref3 => {
    let {
      title: e,
      subtitle: o,
      description: a,
      consents: n,
      denyAllLabel: d,
      grantAllLabel: r,
      saveLabel: c,
      onConsentChange: f,
      onDenyAll: _,
      onGrantAll: l,
      onSave: i,
      color: s = "#1890CC",
      expires: u = /* @__PURE__ */new Date().getDate() + 7,
      classNames: h
    } = _ref3;
    const t = re(h),
      p = n.map(_ref4 => {
        let {
          id: g
        } = _ref4;
        return g;
      }),
      [C, z] = M("@rendpro/consent-mode-banner"),
      [x, L] = v.useState(!1),
      [w, D] = ne("@rendpro/consent-mode-banner:consents", n.reduce((g, _ref5) => {
        let {
          id: b,
          defaultChecked: y
        } = _ref5;
        return {
          ...g,
          [b]: y
        };
      }, {})),
      U = v.useMemo(() => n.reduce((g, _ref6) => {
        let {
          id: b
        } = _ref6;
        return {
          ...g,
          [b]: !0
        };
      }, {}), [n]),
      T = v.useMemo(() => n.reduce((g, _ref7) => {
        let {
          id: b
        } = _ref7;
        return {
          ...g,
          [b]: !1
        };
      }, {}), [n]);
    v.useEffect(() => {
      C || setTimeout(() => L(!0), 500);
    }, []), v.useEffect(() => {
      C && w && (i == null || i(w));
    }, [C, w]), v.useEffect(() => {
      x ? document.body.style.overflow = "hidden" : document.body.style.overflow = "auto";
    }, [x]);
    const $ = g => b => {
        const y = b.target.checked,
          k = {
            ...w,
            [g]: y
          };
        D(k), f == null || f(k);
      },
      W = (g, b) => () => {
        (g == null ? void 0 : g()) && (b === "denyAll" ? D(T) : b === "grantAll" && D(U), L(!1), z("cookie-consent-mode", {
          expires: u
        }));
      },
      F = W(() => {
        var _ref8;
        return (_ref8 = _ == null ? void 0 : _(p)) !== null && _ref8 !== void 0 ? _ref8 : !0;
      }, "denyAll"),
      P = W(() => {
        var _ref9;
        return (_ref9 = l == null ? void 0 : l(p)) !== null && _ref9 !== void 0 ? _ref9 : !0;
      }, "grantAll"),
      Y = W(() => {
        var _ref10;
        return (_ref10 = i == null ? void 0 : i(w !== null && w !== void 0 ? w : {})) !== null && _ref10 !== void 0 ? _ref10 : !0;
      }, "save");
    return /* @__PURE__ */m("div", {
      className: A(t.wrapper, x && t.wrapperOpened),
      role: "dialog",
      "aria-labelledby": "consent-mode-banner",
      style: {
        // @ts-ignore
        "--rendpro-consentmode-banner-color": s
      },
      children: /* @__PURE__ */m("div", {
        className: t.innerWrapper,
        children: /* @__PURE__ */N("div", {
          className: A(t.frame, x && t.frameOpened),
          children: [/* @__PURE__ */N("div", {
            className: t.contentWrapper,
            children: [/* @__PURE__ */m("h2", {
              className: t.title,
              id: "consent-mode-banner",
              children: e
            }), /* @__PURE__ */m("h3", {
              className: t.subtitle,
              children: o
            }), /* @__PURE__ */m("div", {
              className: t.description,
              children: a
            })]
          }), /* @__PURE__ */m("div", {
            className: t.consentsWrapper,
            children: n.map(_ref11 => {
              let {
                id: g,
                label: b,
                defaultChecked: y,
                disabled: k
              } = _ref11;
              return /* @__PURE__ */N("label", {
                className: A(t.consent, k && t.consentDisabled),
                children: [/* @__PURE__ */m("span", {
                  className: t.consentLabel,
                  children: b
                }), /* @__PURE__ */m("input", {
                  type: "checkbox",
                  id: g,
                  defaultChecked: y,
                  className: t.consentCheckbox,
                  onChange: k ? void 0 : $(g),
                  disabled: k
                })]
              }, g);
            })
          }), /* @__PURE__ */N("div", {
            className: t.buttonsWrapper,
            children: [/* @__PURE__ */m("button", {
              className: t.denyAll,
              onClick: F,
              children: d
            }), /* @__PURE__ */m("button", {
              className: t.save,
              onClick: Y,
              children: c
            }), /* @__PURE__ */m("button", {
              className: t.grantAll,
              onClick: P,
              children: r
            })]
          })]
        })
      })
    });
  },
  E = e => function () {
    return typeof O > "u" ? (console.error("ConsentModeBanner: gtag is not defined"), !1) : e(...arguments);
  };
typeof window < "u" && (window.dataLayer = (_window$dataLayer = window.dataLayer) !== null && _window$dataLayer !== void 0 ? _window$dataLayer : []);
const O = function () {
    window.dataLayer.push(arguments);
  },
  se = () => {
    const e = E(() => (O("consent", "update", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "denied"
      }), !0)),
      o = E(n => (O("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        personalization_storage: "granted",
        security_storage: "granted"
      }), !0)),
      a = E(n => {
        const d = {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied",
          functionality_storage: "denied",
          personalization_storage: "denied",
          security_storage: "denied"
        };
        return n.essential && (d.security_storage = "granted", d.functionality_storage = "granted"), n.preferences && (d.personalization_storage = "granted"), n.statistics && (d.analytics_storage = "granted"), n.marketing && (d.ad_storage = "granted", d.ad_user_data = "granted", d.ad_personalization = "granted"), O("consent", "update", d), !0;
      });
    return {
      onDenyAll: e,
      onGrantAll: o,
      onSave: a
    };
  },
  de = e => ({
    consents: [{
      id: "essential",
      label: e.essential,
      defaultChecked: !0,
      disabled: !0
    }, {
      id: "preferences",
      label: e.preferences,
      defaultChecked: !1
    }, {
      id: "statistics",
      label: e.statistics,
      defaultChecked: !1
    }, {
      id: "marketing",
      label: e.marketing,
      defaultChecked: !1
    }]
  });
export { ie as ConsentModeBanner, ae as CookieNotice, de as defaultConsents, se as defaultHandlers };